<template>
  <div class="content-container journal-container">
    <h2 class="content-title">{{title}}</h2>
    <div class="journal-list listing" :class="{'images-loaded':imgsLoaded}">
      <article v-for="(slide,si) in slides" :key="slide.nid" :data-index="si" :data-path="slide.path" class="journal-entry" v-on:mouseover="updateCurrId(slide.nid)">
        <figure class="half-width float-first" v-if="slide.hasSingleImage">
          <img :src="slide.image.sizes[defaultSize]" :width="slide.image.attributes.width" :height="slide.image.attributes.height" />
          <figcaption v-if="slide.image.attributes">
            <div class="inner">
              {{slide.image.attributes.title}}
            </div>
          </figcaption>
        </figure>
        <div class="core-content half-width float-second">
          <h4 class="blog-title">{{slide.title}}</h4>
          <time class="date" :title="slide.date">{{slide.date|toYear}}</time>
          <div class="body" v-html="slide.body"></div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'journal',
  components: {
  },
  props: {
  },
  data: function () {
    return {
      title: 'Journal',
      loading: false,
      slides: [],
      numSlides: 0,
      scrolling: false,
      loadedMore: false,
      defaultSize: 'max_720x720',
      hasFullImage: false,
      mediaPlaying: '',
      imgsLoaded: false,
      fullCaption: '',
      fullSizes: {}
    }
  },
  beforeRouteEnter: function (to,from,next) { 
    next(function(vm) {
      vm.initPage()
    })
  },
  created: function () {
  },
  watch: {
  },
  methods: {
    initPage: function () {
      this.fullSizes = this.$parent.fullSizes
      if (this.loading !== true) {
        if (this.$parent.infoLoaded) {
          this.loadSlides(false)
          this.$parent.removeContainerClass('loading')
        } else {
          var comp = this
          setInterval(function () {
            if (comp.$parent.infoLoaded && comp.numSlides < 1) {
              comp.loadSlides(false)
            }
          }, 200)
        }
      }
    },
    loadSlides: function (more) {
      var comp = this
      var refName = 'journals'
      this.$parent.loadData('journals', function(data) {
        comp.addSlides(data)
        comp.$parent.removeContainerClass('loading')
      })  
    },
    loadMoreSlides: function () {
      if (this.loadedMore === false) {
        this.loadSlides(true)
        this.loadedMore = true
      }
    },
    addSlides: function (data, more) {
      this.numSlides = data.num_items
      var slides = []
      for (var i = 0; i < this.numSlides; i++) {
        if (typeof data.items[i] === 'object') {
          var it = data.items[i]
          if (i === 0) {
            this.$parent.currId = it.nid
          }
          it.numImages = 0
          it.hasSections = false
          it.hasSingleImage = false
          if (it.image) {
            it.hasSingleImage = (it.image instanceof Object && it.image.sizes)
          }
          if (it.sections) {
            it.hasSections = it.sections.length > 0
          }
          if (it.images instanceof Array || it.hasSingleImage) {
            this.processImages(it)
            if (it.hasSingleImage) {
              it.numImages = 1
            }
          }
          slides.push(it)
        }
      }
      if (more) {
        this.slides = _.union(this.slides,slides);
      } else {
        this.slides = slides
      }
      this.numSlides = this.slides.length
      var comp = this
      setTimeout(function () {
        comp.imgsLoaded = true
        this.loading = false
      }, 1000)
      setTimeout(this.layout, 1750)
      this.$parent.pageHeight = comp.$parent.calcPageHeight()
    },
    processImages: function (slide) {
      slide.hasImages =  false
      slide.images = []
      if (slide.image) {
        if (slide.image.sizes) {
          slide.hasImages =  true
          slide.numImages = 1
          slide.images = [slide.image]
        }
      }
      for (var j = 0; j < slide.numImages; j++) {
        var cln = 'index-0 active' + j
        var attrs = slide.images[j].attributes
        if (j === 0) {
          cln += ' active'
        }
        attrs.className = cln
        if (slide.images[j].sizes) {
          var sizes = slide.images[j].sizes
          if (typeof sizes === 'object') {
            slide.images[j] = {
              sizes: sizes,
              attributes: attrs,
              type: slide.images[j].type,
              picture: slide.images[j].picture
            }
          }
        }
      }
      slide.image = slide.images[0]
    },
    addImageClasses: function (slide) {
      slide.imageClasses = 'num-images-' + slide.numImages
      if (slide.numImages > 1) {
        slide.imageClasses += ' has-many'
      }
      if (!slide.image_layout) {
        slide.image_layout = 'flex-row'
      }
      if (slide.numImages > 1 && slide.image_layout !== 'max-1') {
        slide.imageClasses += ' rows'
      }
      slide.imageClasses += ' ' + slide.image_layout
    },
    updateCurrId: function(nid) {
      this.$parent.currId = nid
    }
  }
}
</script>


// WEBPACK FOOTER //
// Journal.vue?60487640